// // services/socket.ts
// import store from "@store/index";
// import env from "env";
// import { io, Socket } from "socket.io-client";
// import { refreshTokenService } from "./auth.service";
// // import { apiConstants } from "@constants/apiContants";
// // import { store } from "@redux/store";
// // import { Alert } from "react-native";
// // import { authHelpers, baseApi } from "./baseApi";
// // import { logoutUser, setUser } from "@redux/slices/userSlice";
// // import AsyncStorage from "@react-native-async-storage/async-storage";
// // import { updateAccessToken, logoutUser } from "@redux/slices/userSlice";
// // import { refreshTokenAPI } from "@services/auth"; // Your refresh API


// // export const refreshTokenAPI = async (refreshToken: string): Promise<string> => {
// //   const response = await fetch(`${env.apiLink}${apiConstants.refreshToken}`, {
// //     method: "POST",
// //     headers: {
// //       "Content-Type": "application/json",
// //     },
// //     body: JSON.stringify({ refreshToken }),
// //   });

// //   if (!response.ok) {
// //     throw new Error(`Refresh token failed with status ${response.status}`);
// //   }

// //   const data = await response.json();
// //   if (!data?.accessToken) {
// //     throw new Error("No access token in refresh response");
// //   }
// //   return data.data;
// // };



// let socket: Socket | null = null;
// let isRefreshing = false;

// export const initializeSocket = async (token: string): Promise<Socket> => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//   }
//     const sessionId = localStorage.getItem("sessionId");
//    if (!sessionId) return null;

//   socket = io(env.apiLink, {
//     // auth: { token },
//     auth: { sessionId },
//     transports: ["websocket","polling"],
//     autoConnect: true,
//     reconnection: true,
//     reconnectionAttempts: 5,
//     reconnectionDelay: 2000,
//   });

//   socket.removeAllListeners();

//   socket.on("connect", async () => {
//     console.log("✅ Socket connected:", socket?.id);
//     // store.dispatch(baseApi.util.invalidateTags(['message']))
//   });

//   socket.on("disconnect", reason => {
//     console.log("❌ Socket disconnected:", reason);
//   });

//   socket.on("connect_error", async (err: any) => {
//     console.log("⚠️ Socket connect_error:", err.message);

//     // 🔒 If token expired, try refresh logic
//     if ((err?.message?.includes("Authentication error") || err?.message?.includes("mismatched")) && !isRefreshing) {
//       isRefreshing = true;

//       try {
//         // window.alert('socket')
//         const state = store.getState();
//         const oldRefreshToken = state.user.refreshToken;
//         if (!oldRefreshToken) {
//           // Alert.alert('Session timed out.')
//           // authHelpers.clearTokens();
//           // store.dispatch(logoutUser());
//           throw new Error("No refresh token")
//         };

//         const response: any = await refreshTokenService(oldRefreshToken);
//         if (response.token) {
//           // Store the new tokens
//           if (response.token && response.refreshToken) {
//             // store.dispatch(setUser({
//             //   ...response,
//             //   token: response.token,
//             //   refreshToken: response.refreshToken
//             // }));
//             // await AsyncStorage.setItem('token', response.token);
//             // await AsyncStorage.setItem('refreshToken', response.refreshToken);
//             // Re-initialize socket with new token
//             socket?.disconnect();
//             socket = io(env.apiLink, {
//               auth: { token: response?.token },
//               transports: ["websocket"],
//             });

//             socket.connect();
//             // result = await baseQuery(args, api, extraOptions);
//           } else {
//             // Handle missing tokens
//             // await authHelpers.clearTokens();
//           }
//         } else {
//           // Handle refresh token failure
//           // You might want to logout the user here
//           // Alert.alert('Session timed out.')
//           // authHelpers.clearTokens();
//           // store.dispatch(logoutUser());
//           // await AsyncStorage.multiRemove(['token', 'refreshToken']);
//         }


//       } catch (refreshError) {
//         console.error("❌ Token refresh failed", refreshError);
//         // store.dispatch(logoutUser());
//       } finally {
//         isRefreshing = false;
//       }
//     }
//   });

//   return socket;
// };

// export const getSocket = (): Socket | null => socket;

// export const disconnectSocket = (): void => {
//   if (socket) {
//     console.log("🔌 Socket disconnected manually");
//     socket.disconnect();
//     socket = null;
//   }
// };



// socket.js
import { io } from "socket.io-client";

let socket = null;

// In socket.ts - UPDATE the initializeSocket function
// In socket.ts - UPDATE the initializeSocket function
export const initializeSocket = () => {
  if (socket && socket.connected) {
    console.log("✅ Socket already connected:", socket.id);
    return socket;
  }

  const sessionId = localStorage.getItem("sessionId");
  console.log("🔄 Initializing socket with sessionId:", sessionId);
  
  if (!sessionId) {
    console.warn("❌ No sessionId found for socket connection");
    return null;
  }

  // 🔥 FIX: Use the correct backend URL
  const backendUrl = process.env.REACT_APP_WS_URL || 'https://api.comtracked.com';
  console.log("🔗 Connecting to backend:", backendUrl);

  socket = io(backendUrl, {
    auth: { sessionId },
    transports: ["websocket", "polling"],
    autoConnect: true,
    timeout: 10000, // Increase timeout
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected successfully, ID:", socket.id);
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
    console.error("❌ Connection details:", {
      url: backendUrl,
      sessionId: sessionId ? "present" : "missing",
      sessionIdLength: sessionId?.length
    });
  });

  socket.on("disconnect", (reason) => {
    console.log("🔌 Socket disconnected:", reason);
  });

  return socket;
};
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
